/* Bursting Supplies — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var money = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: money }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- scrim + panel management ---------- */
  var scrim = $('[data-scrim]');
  var openPanel = null;
  function closeAll() {
    if (openPanel) { openPanel.classList.remove('is-open'); openPanel.setAttribute('aria-hidden', 'true'); openPanel = null; }
    if (scrim) { scrim.classList.remove('is-open'); scrim.hidden = true; }
    document.body.classList.remove('no-scroll');
  }
  function open(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); openPanel = el;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
    document.body.classList.add('no-scroll');
    var f = el.querySelector('input,button,a'); if (f) setTimeout(function () { f.focus(); }, 260);
  }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open]');
    if (t) { e.preventDefault(); open($('[data-panel="' + t.getAttribute('data-open') + '"]')); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
  });

  /* ---------- sticky header shadow ---------- */
  var hdr = $('[data-header]');
  if (hdr) {
    var onScroll = function () { hdr.setAttribute('data-stuck', window.scrollY > 8 ? 'true' : 'false'); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile nav accordions ---------- */
  $$('[data-mtoggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var panel = b.nextElementSibling; if (!panel) return;
      var openNow = panel.classList.toggle('is-open');
      b.setAttribute('aria-expanded', openNow);
    });
  });

  /* ---------- accordions ---------- */
  $$('.acc__btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = document.getElementById(b.getAttribute('aria-controls'));
      var isOpen = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', String(!isOpen));
      if (p) p.hidden = isOpen;
    });
  });

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach(function (group) {
    var tabs = $$('[role=tab]', group);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var sel = t === tab;
          t.setAttribute('aria-selected', String(sel));
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !sel;
        });
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var step = b.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.min || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main] img', g);
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || main.alt;
        $$('[data-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', String(x === t)); });
      });
    });
  });

  /* ---------- variant selection ---------- */
  $$('[data-variants]').forEach(function (form) {
    var dataEl = $('[data-variant-json]', form);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-price]', form);
    var cmpEl = $('[data-compare]', form);
    var btn = $('[data-add]', form);
    var stockEl = $('[data-stock]', form);
    var skuEl = $('[data-sku]', form);

    function currentOptions() {
      return $$('[data-opt]', form).map(function (grp) {
        var checked = $('input:checked', grp);
        if (checked) return checked.value;
        var sel = grp.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      $$('[data-opt-value]', form).forEach(function (el) {
        var label = el.closest('.opt').querySelector('[data-selected]');
        if (label && el.querySelector('input:checked')) label.textContent = el.querySelector('input').value;
      });
      if (!match) {
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (cmpEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          cmpEl.textContent = fmt(match.compare_at_price); cmpEl.hidden = false;
          priceEl && priceEl.classList.add('price--sale');
        } else { cmpEl.hidden = true; priceEl && priceEl.classList.remove('price--sale'); }
      }
      if (skuEl) skuEl.textContent = match.sku || '';
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.getAttribute('data-default') || 'Add to cart') : (btn.getAttribute('data-soldout') || 'Sold out');
      }
      if (stockEl) {
        var dot = stockEl.querySelector('.dot'), txt = stockEl.querySelector('[data-stock-text]');
        if (!match.available) { dot.className = 'dot dot--out'; txt.textContent = stockEl.getAttribute('data-out'); }
        else if (match.inventory_management && match.inventory_quantity > 0 && match.inventory_quantity <= 10) {
          dot.className = 'dot dot--low'; txt.textContent = (stockEl.getAttribute('data-low') || 'Only [c] left').replace('[c]', match.inventory_quantity);
        } else { dot.className = 'dot'; txt.textContent = stockEl.getAttribute('data-in'); }
      }
      if (history.replaceState && match.id) {
        var u = new URL(window.location.href); u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u.toString());
      }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) update(); });
    update();
  });

  /* ---------- cart ---------- */
  function refreshCartUI(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
    });
    var drawerBody = $('[data-cart-body]');
    if (drawerBody) {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-inner]');
          var target = $('[data-cart-inner]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        });
    }
  }
  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    var btn = $('[type=submit]', form);
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        refreshCartUI(cart);
        open($('[data-panel="cart"]'));
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-line]');
    if (rm) {
      e.preventDefault();
      var line = parseInt(rm.getAttribute('data-remove-line'), 10);
      rm.closest('.cart-line').classList.add('loading');
      cartFetch('/cart/change.js', { line: line, quantity: 0 }).then(refreshCartUI);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line-qty'), 10);
    input.closest('.cart-line').classList.add('loading');
    cartFetch('/cart/change.js', { line: line, quantity: parseInt(input.value, 10) })
      .then(function (cart) { refreshCartUI(cart); if (document.body.classList.contains('template-cart')) location.reload(); });
  });

  /* ---------- predictive search ---------- */
  var sInput = $('[data-search-input]');
  if (sInput) {
    var results = $('[data-search-results]');
    var timer;
    sInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = sInput.value.trim();
      if (q.length < 2) { if (results) results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources.results.product || []).map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=104" alt="" width="52" height="52" loading="lazy">' : '<img alt="" width="52" height="52">';
              return '<a href="' + p.url + '">' + img + '<div><strong>' + p.title + '</strong><span>' + (p.price ? p.price : '') + '</span></div></a>';
            });
            (d.resources.results.collection || []).forEach(function (c) {
              items.push('<a href="' + c.url + '"><div><strong>' + c.title + '</strong><span>Collection</span></div></a>');
            });
            if (results) results.innerHTML = items.join('') || '<p style="text-align:center;color:var(--muted)">No matches yet.</p>';
          });
      }, 220);
    });
  }

  /* ---------- facet auto-submit ---------- */
  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form)).toString();
      var url = form.getAttribute('action') + (params ? '?' + params : '');
      var grid = $('[data-product-grid]');
      if (grid) grid.classList.add('loading');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-product-grid]', '[data-facets]', '[data-result-count]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), cur = $(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        history.pushState({}, '', url);
        if (grid) grid.classList.remove('loading');
      });
    });
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
  }
})();
